import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { CheckCircle2, Heart } from 'lucide-react';

const DonationSuccess = () => {
  const [count, setCount] = useState(8);

  useEffect(() => {
    const t = setInterval(() => setCount((c) => (c > 0 ? c - 1 : 0)), 1000);
    const r = setTimeout(() => { window.location.href = '/'; }, 8000);
    return () => { clearInterval(t); clearTimeout(r); };
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-50 px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-10 text-center" data-testid="donation-success-page">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <CheckCircle2 className="w-9 h-9 text-green-600" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-3">Thank You for Your Donation</h1>
        <p className="text-gray-600 mb-2">
          Your payment has been submitted and is being confirmed. Your generosity helps us fight chronic pain diseases and transform lives.
        </p>
        <p className="text-sm text-gray-500 mb-8 flex items-center justify-center gap-1">
          <Heart className="w-4 h-4 text-blue-600" /> Yaweh: Transforming Lives, One Purpose at a Time
        </p>
        <Link to="/">
          <Button className="bg-blue-600 hover:bg-blue-700" data-testid="success-home-button">
            Return to Home ({count})
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default DonationSuccess;
